if (!customElements.get('debeyond-sticky-buy')) {
  customElements.define('debeyond-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.product || !this.form) return;
      this.select = this.querySelector('[data-db-size]');
      this.button = this.querySelector('[data-db-add]');
      this.nativeButton = this.form.querySelector('[name="add"]');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.chosen = new URL(location.href).searchParams.has('variant');
      this.product.addEventListener('change', event => {
        if (event.target.closest('variant-selects')) {
          this.chosen = true;
          this.pendingVariant = [...this.select.options].find(option => option.dataset.option === event.target.value)?.value;
        }
        this.sync();
      }, options);
      this.select.addEventListener('change', () => {
        if (!this.select.value) { this.chosen = false; this.sync(); return; }
        this.chosen = true;
        this.pendingVariant = this.select.value;
        this.button.disabled = true;
        const url = new URL(this.product.dataset.url, location.origin);
        url.searchParams.set('variant', this.select.value);
        url.searchParams.set('section_id', this.product.dataset.section);
        this.product.resetProductFormState();
        this.product.renderProductInfo({
          requestUrl: url.toString(),
          targetId: this.select.id,
          callback: this.product.handleUpdateProductInfo(this.product.dataset.url)
        });
        this.sync();
      }, options);
      this.button.addEventListener('click', () => {
        if (!this.chosen || !this.select.value) { this.select.focus(); this.select.showPicker?.(); return; }
        if (this.form.querySelector('[name="id"]').value !== this.select.value) return;
        if (!this.nativeButton.disabled && this.nativeButton.getAttribute('aria-disabled') !== 'true') {
          this.nativeButton.click();
        }
      }, options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.nativeButton, {attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      this.form.addEventListener('change', () => this.sync(), options);
      this.hidden = false;
      this.sync();
    }
    sync() {
      const id = this.form.querySelector('[name="id"]').value;
      if (this.pendingVariant === id) this.pendingVariant = null;
      if (this.chosen) this.select.value = this.pendingVariant || id;
      else this.select.value = '';
      const option = [...this.select.options].find(item => item.value === id);
      if (option) this.querySelector('[data-db-price]').textContent = option.dataset.price;
      this.button.textContent = this.chosen ? this.dataset.add : this.dataset.choose;
      this.button.disabled = this.chosen && (Boolean(this.pendingVariant) || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true' || !option || option.disabled);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
document.addEventListener('change', event => {
  if (!event.target.matches('[data-db-delivery]')) return;
  const output = event.target.closest('details').querySelector('[data-db-delivery-result]');
  output.textContent = event.target.selectedOptions[0].dataset.fee || '';
});
